import script from "./PreferredAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./PreferredAssets.vue?vue&type=script&setup=true&lang=js"

import "./PreferredAssets.vue?vue&type=style&index=0&id=bb5d6398&lang=scss"

const __exports__ = script;

export default __exports__